import PropTypes from 'prop-types';

import { cymbioColors } from '../../../utils/colors';

const stroke = cymbioColors.analytics.darkGreen;

export function ArrowCaretItalic({ color = stroke }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path d="M5.00015 11.5L11.0002 5.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.60018 5.49993H11.0002V10.8999" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

ArrowCaretItalic.propTypes = {
  color: PropTypes.string,
};
